/* global axios */
import ApiClient from './ApiClient';

class MotorReservaConfigAPI extends ApiClient {
  constructor() {
    super('motor_reserva_config', { accountScoped: true });
  }

  update(data) {
    return axios.put(this.url, data);
  }

  addPhoto(file, kind = 'cover') {
    const formData = new FormData();
    formData.append('photo', file);
    formData.append('kind', kind);
    return axios.post(`${this.url}/add_photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removePhoto(photoId, kind = 'cover') {
    return axios.delete(`${this.url}/remove_photo`, {
      params: { photo_id: photoId, kind },
    });
  }

  setLogo(file) {
    return this.addPhoto(file, 'logo');
  }

  clearLogo() {
    return axios.delete(`${this.url}/remove_photo`, {
      params: { kind: 'logo' },
    });
  }

  testAsaas(apiKey, environment) {
    return axios.post(`${this.url}/test_asaas`, {
      api_key: apiKey,
      environment,
    });
  }
}

export default new MotorReservaConfigAPI();
